import React from "react";
import i18next from "i18next";
import { toast } from "react-toastify";
import validator from "validator";
import ReactGA from "react-ga";
import {
  EMPTY_VALIDATION,
  EMAIL_VALIDATION,
  PHONE_VALIDATION,
  SELECTED_VALIDATION,
  RADIO_VALIDATION,
  PASSWORD_VALIDATION,
} from "../constants";

export const AppContext = React.createContext({
  userInfo: null,
  setUserInfo: () => {},
});

//esta función será la forma de construir el objeto de info de usuario
export const buildUserInfo = (context, info) => {
  if (context) {
    context.setUserInfo(info);
  }
};

export const changeLanguage = (lng) => {
  i18next.changeLanguage(lng);
};

export const getLanguage = () => i18next.language;

export const t = (key, params) => {
  return i18next.t(key, params);
};

export const sluglify = (text) => {
  //codigo basado en https://stackoverflow.com/a/48000411/6465426
  return text
    .toString() // se convierte a string
    .normalize("NFD") // se normaliza el texto https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/String/normalize
    .replace(/[\u0300-\u036f]/g, "") // Se remueven caracteres ilegales para url
    .replace(/\s+/g, "-") // Se cambian espacios por guion medio
    .toLowerCase() // Se deja en minuscula
    .replace(/&/g, "-and-") // se reemplazan los & por -and-
    .replace(/[^a-z0-9-]/g, "") // se remueve todo lo que no sea numero o letra
    .replace(/-+/g, "-") // se remueven guiones duplicados
    .replace(/^-*/, "") // Se remueven los guiones al inicio de la cadena
    .replace(/-*$/, ""); // se remueven los guiones al final de la cadena
};

export const isValidJSONString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const GAevent = (categoryName, eventName, options = {}) => {
  ReactGA.event({
    category: categoryName, // Required
    action: eventName, // Required
    label: options.labelName || "",
    value: options.value || 0,
    nonInteraction: options.nonInteraction || false,
  });
};

export const GAset = (options) => {
  ReactGA.set(options);
};

export const animateCSS = (element, animationName, callback) =>
  new Promise((resolve, reject) => {
    const node = document.querySelector(element);
    node.classList.add("animate__animated", animationName);

    function handleAnimationEnd() {
      node.classList.remove("animate__animated", animationName);
      node.removeEventListener("animationend", handleAnimationEnd);

      if (typeof callback === "function") callback();
      resolve("Animation ended");
    }

    node.addEventListener("animationend", handleAnimationEnd);
  });

export const showToast = (msg, type = "success") => {
  if (type === "success") {
    toast.success(msg);
  } else if (type === "error") {
    toast.error(msg);
  } else if (type === "warning") {
    toast.warn(msg);
  } else if (type === "info") {
    toast.info(msg);
  }
};

export const validarCampo = (data, validations, errors, labels, name) => {
  //valida que si exista un valor en el campo
  if (
    validations[name].some((v) => v === EMPTY_VALIDATION) &&
    validator.isEmpty(data[name].trim())
  ) {
    errors[name] = `${t("validacionDebeIngresar")} ${labels[name]}`;
  }
  //valida que si existe un valor en el campo que este sea un teléfono válido
  else if (
    validations[name].some((v) => v === PHONE_VALIDATION) &&
    !validator.isEmpty(data[name].trim()) &&
    !/\+569[0-9]{8}/.test(data[name].trim())
  ) {
    errors[name] = t("validacionTelefono");
  }
  //valida que si existe un valor en el campo que este sea un email válido
  else if (
    validations[name].some((v) => v === EMAIL_VALIDATION) &&
    !validator.isEmpty(data[name].trim()) &&
    !validator.isEmail(data[name].trim())
  ) {
    errors[name] = t("validacionEmail");
  } else if (
    validations[name].some((v) => v === PASSWORD_VALIDATION) &&
    (data[name].trim() === "" ||
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/.test(
        data[name].trim()
      ))
  ) {
    errors[name] = t("validacionClave");
  }
  //valida que un select tengo un valor seleccionado
  else if (
    validations[name].some((v) => v === SELECTED_VALIDATION) &&
    (data[name] === null ||
      (typeof data[name] === "object" && Object.keys(data[name]).length === 0))
  ) {
    errors[name] = t("validacionSeleccionOpcion");
  }
  //valida que exista una opción seleccionada (de checkbox (NO MÚLTIPLE))
  else if (
    validations[name].some((v) => v === RADIO_VALIDATION) &&
    data[name] === null
  ) {
    errors[name] = t("validacionSeleccionOpcion");
  }
  //valida que un campo de texto coincida con otro
  else if (validations[name].some((v) => v.indexOf("matchField") >= 0)) {
    //se identifica el nombre del campo a comparar
    const otherField = validations[name].find(
      (v) => v.indexOf("matchField") >= 0
    );
    if (
      otherField &&
      otherField.split("-")[1] &&
      data[name] !== data[otherField.split("-")[1]]
    ) {
      errors[name] = `${t("validacionDebeCoincidir")} ${
        labels[otherField.split("-")[1]]
      }`;
    } else {
      delete errors[name];
    }
  }
  //valida que un campo tenga un minimo de caracteres
  else if (validations[name].some((v) => v.indexOf("minLength") >= 0)) {
    //se identifica el nombre del campo a comparar
    const field = validations[name].find((v) => v.indexOf("minLength") >= 0);
    if (
      field &&
      field.split("-")[1] &&
      data[name].length < parseInt(field.split("-")[1])
    ) {
      errors[name] = `${labels[name]} ${t("validacionMinCaracteres")} ${
        field.split("-")[1]
      } ${t("caracteres")}`;
    } else {
      delete errors[name];
    }
  }
  //si no se encuentran errores se eliminan los errores del objeto
  else {
    delete errors[name];
  }
  return errors;
};

export const validarCampos = (data, validations, errors, labels, campos) => {
  campos.forEach((name) => {
    errors = validarCampo(data, validations, errors, labels, name);
  });
  return errors;
};
